export const marketingConfig = {
  branding: {
    label: 'Branding',
    type: 'text',
  },
  brandingType: {
    label: 'Branding Type',
    type: 'select',
    isVisible: true,
    data: [{ id: 'MyEyeDr.' }, { id: 'Rx-Optical' }, { id: 'White Label' }, { id: 'Co-Branded' }, { id: 'HOOL' }],
    allowClear: true,
  },
  zocDocPatientType: {
    label: 'ZocDoc patient Type',
    type: 'select',
    isVisible: true,
    data: [
      { id: 'New Patients Only' },
      { id: 'Existing Patients Only' },
      { id: 'New & Existing Patients' },
      { id: 'No Patients' },
    ],
    allowClear: true,
  },
  legacyName: {
    label: 'Legacy Name',
    type: 'text',
  },
  mediaMarket: {
    label: 'Media Market',
    type: 'text',
  },
  msa: {
    label: 'MSA',
    type: 'text',
  },
  top5zip: {
    label: 'Top5',
    type: 'text',
  },
  digitalMetroCategory: {
    label: 'Digital Metro Category',
    type: 'text',
  },
  storefrontCategory: {
    label: 'Storefront Category',
    type: 'select',
    isVisible: true,
    data: [{ id: 'Pedestrian' }, { id: 'Rural' }, { id: 'Virtual' }, { id: 'Destination' }, { id: 'Other' }],
    allowClear: true,
  },
  otherSfcComment: {
    label: 'Storefront Category Comment',
    type: 'text',
    isVisible: false,
  },
  googleBookOnlineButtonType: {
    label: 'Google Book Online Button Type',
    type: 'select',
    isVisible: true,
    data: [{ id: 'Yext' }, { id: 'ZocDoc' }, { id: 'Other' }, { id: 'None' }],
    allowClear: true,
  },
  byPassForm: {
    label: 'ByPass Form',
    type: 'checkbox',
    isVisible: true,
  },
  practiceAffiliationEmailSendDate: {
    label: 'Practice Affiliation Email Send Date',
    type: 'unrestricted-date',
    isVisible: true,
  },
};
